
import React from 'react';

import "../../App.css";
import "./HomePage.css";

// IMAGES
import PACS_LOGO from "../../images/pacs512.png";
import {ROUTES} from "../../routes/Routes";
import LandingPane from "../../panes/Landing/LandingPane";
import NavBar from "../../components/navbar/NavBar";
import RegistrationPane from "../../panes/Register/RegistrationPane";
import VenuePane from "../../panes/Venue/VenuePane";
import SpeakerPane from "../../panes/Speakers/SpeakerPane";
import AgendaPane from "../../panes/Agenda/AgendaPane";
import FormModal from "../../modals/form-modal/FormModal";
import FeedbackForm from "../../forms/feedback/FeedbackForm";
import PresentationPane from "../../panes/Presentation/PresentationPane";
import {useSearchParams} from "react-router";
import RegistrationCompletePane from "../../panes/Register/RegistrationCompletePane";
import FeedbackCompletePane from "../../panes/Feedback/FeedbackCompletePane";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import EmailIcon from "@mui/icons-material/Email";

export default function HomePage(props) {

    const [searchParms] = useSearchParams();
    const index = searchParms.has("index") ? searchParms.get("index") : 0;

    const [modalOpen, setModalOpen] = React.useState(false);
    const [selected, setSelected] = React.useState(index);
    const panes = [
        <LandingPane onFeedback={()=>setModalOpen(true)} setSelected={setSelected} />,
        <RegistrationPane setSelected={setSelected} />,
        <VenuePane/>,
        <AgendaPane/>,
        <SpeakerPane/>,
        <PresentationPane/>,
        <RegistrationCompletePane/>,
        <FeedbackCompletePane/>
    ]

    const goHome = () => {
        setSelected(0);
    }

    const handleFeedbackSuccess = () => {
        setModalOpen(false);
        setSelected(7);
    }

    return <React.Fragment>

        <div className={""}>

            <div className={"hp-mainlogo"} onClick={goHome}>
                {/*LOGO*/}
                <div className={"default-text-align-center homepage-header-logo"}>
                    <img className={"pacs-logo"} src={PACS_LOGO} alt="logo"/>
                </div>
                <div
                    style={{
                        fontFamily: "Balthazar Regular",
                        fontSize: "48px"
                    }}
                >
                    PACT SUMMIT
                </div>
                <div
                    style={{
                        fontFamily: "Balthazar Regular",
                        fontSize: "38px",
                        marginTop: "-10px"
                    }}
                    className={"default-font-xlarge"}
                >
                    2025
                </div>
            </div>
            <div style={{
                    // maxWidth: "360px",
                    margin: "auto",
                    paddingTop: "20px",
                }}
                className={"default-font-xxlarge default-font-bold"}
            >
                <div style={{
                    width: "100%",
                    color: "#0d93bb",
                    fontFamily: "Playfair Display",
                    textAlign: "center",
                }}>
                    <span>San Diego, CA</span>
                </div>
                <div style={{
                    width: "100%",
                    color: "#0d93bb",
                    fontFamily: "Playfair Display",
                    textAlign: "center",
                }}>
                    <span>Nov 6th &nbsp;&nbsp;8:30AM</span>
                </div>
            </div>
            <div>
                <NavBar routes={ROUTES} selected={selected} setSelected={setSelected} />
            </div>
            <div>
                {panes[selected]}
            </div>
            <div
                className={"venue-icon-frame"}
            >
                <div
                    className={"venue-icon-div"}
                >
                    <div>
                        <PhoneAndroidIcon className={"venue-icon"}/>
                    </div>
                    <div className={"default-margin-top-large"}>
                        <div className={"venue-std-font default-font-bold"}>
                            Call Us
                        </div>
                        <div className={"venue-std-font"}>
                            (858)-345-6002
                        </div>
                    </div>
                </div>
                <div className={"venue-icon-div"}>
                    <div>
                        <EmailIcon className={"venue-icon"}/>
                    </div>
                    <div className={"default-margin-top-large"}>
                        <div className={"venue-std-font default-font-bold"}>
                            Email Us
                        </div>
                        <div className={"venue-std-font"}>
                            contact@pactsummit.com
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    maxWidth: "600px",
                    margin: "auto",
                    paddingTop: "30px"
                }}
            >
                <div className={"default-align-center default-justify-center default-flex-size"}>
                    <img src={PACS_LOGO} alt="logo" height={100}/>
                </div>
                <div
                    style={{
                        flexGrow: 100,
                        paddingBottom: "50px"
                    }}
                    className={"default-align-center default-justify-center"}>
                    (c) 2025. All Rights Reserved
                </div>
            </div>
        </div>

        <FormModal
            open={modalOpen}
            titleText={"Feedback"}
            content={<FeedbackForm onSuccess={handleFeedbackSuccess} onClose={()=>{setModalOpen(false)}}/>}
            height={365}
        />

    </React.Fragment>
}